export default __webpack_public_path__ + "static/media/university-tech.499ddc04.jpg";